import {
  MutateOptions,
  QueryOptions,
  useCreate,
  useDelete,
  useGetOne,
  useUpdate,
} from "@imminently/react/store/query";
import { useResources } from "@imminently/react/ui/resource/hooks";

import { UserAccount } from "./types";

export const useUser = (id: string, options?: QueryOptions) => {
  return useGetOne<UserAccount>(id, "Users", id, options);
};

export const useUsers = (key: string, filter = {}) => {
  return useResources<UserAccount>("Users", key, filter);
};

export const useCreateUser = (options: MutateOptions) => {
  return useCreate<UserAccount>("Users", options);
};

export const useUpdateUser = (options: MutateOptions) => {
  return useUpdate<UserAccount>("Users", options);
};

export const useDeleteUser = (options: MutateOptions) => {
  return useDelete<UserAccount>("Users", options);
};
